import Actions from "./RefrigeranteActions";
import { AbstractGetAllStore } from "../common/AbstractStores";
import Dispatcher from "../common/dispatcher";
import { RefrigeranteType } from "../generated";

export class RefrigerantiStore extends AbstractGetAllStore<RefrigeranteType> {
    constructor() {
        super(l => l.id!);
        Dispatcher
            .onfunction(Actions.getAll, data => this.setAll(data));
    }

    public useAll = () => this.useAllWithAction(() => Actions.getAll());
}

export default new RefrigerantiStore();